import React, { useContext } from "react";
import style from "./index.module.scss";
import { CourseContext } from "../Store";
import LoadingBoundary from "components/LoadingBoundary";
import PageSpin from "../components/PageSpin";
import { Provider } from "jotai";
import { paramsAtom } from "service/stores/RollCallStore";
import StuTable from "./components/StuTable";
import RollModal from "./components/RollModal";
import RollCallHeader from "./components/RollCallHeader";

function RollCall() {
    return (
        <div className={style.root}>
            <RollCallHeader />
            <StuTable />
            <RollModal />
        </div>
    );
}

export default function RollCallRoot() {
    const { course } = useContext(CourseContext);

    const params = {
        weekTimeId: course.weekTimeId,
        courseNo: course.courseNo,
        courseSeq: course.courseSeq
    };

    return (
        <LoadingBoundary fallback={<PageSpin />}>
            <Provider initialValues={[[paramsAtom, params]] as any}>
                <RollCall />
            </Provider>
        </LoadingBoundary>
    );
}
